import palette from '../../../../theme/palette';
import { handlePriceDisplayUnit, handlePriceDisplay } from 'common/utils';
import { DashboardKpiTypes } from 'reducers';

export const options = (langDashboard, districtHkiOptions, districtNtOptions, districtKltOptions, relativeRegionHkiTotal, relativeRegionKlnTotal, relativeRegionNtTotal, lang, locale,) => ({

  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  legend: { 
    display: true,
    position: 'top',
    align: 'end' ,
    labels:{fontSize: 10} 
    // labels:{
    //   generateLabels: function(chart){
    //     // 
    //     // 
    //     var data = chart.data;
    //     if (data.labels.length && data.datasets.length ) {
    //       return data.labels.map(function(label, i) {
    //         var meta = chart.getDatasetMeta(0);
    //         var ds = data.datasets[0];
    //         var arc = meta.data[i];
    //         var custom = arc && arc.custom || {};
    //         var getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
    //         var arcOpts = chart.options.elements.arc;
            
    //         var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
            
    //         var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
    //         var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

    //         // We get the value of the current label
    //         var value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];
          
    //           return {
    //             // Instead of `text: label,`
    //             // We add the value to the string
    //             text: label ,
    //             fillStyle: fill,
    //             strokeStyle: stroke,
    //             lineWidth: bw,
    //             hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
    //             index: i
    //           };
    //         });
    //         }
    //       else {
    //       return [];
    //     }
    //   }
    // }
  },
  cornerRadius: 20,
  tooltips: {
    enabled: true,
    mode: 'index',
    intersect: false,
    borderWidth: 1,
    borderColor: palette.divider,
    backgroundColor: palette.white,
    titleFontColor: palette.text.primary,
    bodyFontColor: palette.text.secondary,
    footerFontColor: palette.text.secondary,    
    // callbacks: {
    //     label: function(tooltipItem, data) {
    //       
    //       
    //       var dataset = data.datasets[tooltipItem.datasetIndex];
    //       var index = tooltipItem.index;
    //       // // var backgroundColor = dataset.
    //       return dataset.label[index] + ": " + dataset.data[index];
    //       // return null;
    //     }
    //   }
    displayColors: false,
    callbacks: {
      afterBody: function (tooltipItem, data) {
          if (Object.values(districtHkiOptions).includes(tooltipItem[0].label)) {
            return langDashboard.tooltipdistrictHkiTotal + relativeRegionHkiTotal[DashboardKpiTypes.NEW_PROPERTY_UPDATES - 1];
          } else if (Object.values(districtKltOptions).includes(tooltipItem[0].label)) {
            return langDashboard.tooltipdistrictKlnTotal + relativeRegionKlnTotal[DashboardKpiTypes.NEW_PROPERTY_UPDATES - 1];
          } else if (Object.values(districtNtOptions).includes(tooltipItem[0].label)) {
            return langDashboard.tooltipDistrictNtTotal + relativeRegionNtTotal[DashboardKpiTypes.NEW_PROPERTY_UPDATES - 1];
          }
      },
      label: function (tooltipItem, data) {
          var labelName = data.datasets[tooltipItem.datasetIndex].label;
          switch (labelName) {
            case langDashboard.own:
              return langDashboard.tooltipOwnTotal + tooltipItem.value;
            case langDashboard.labelDistrict:
              return tooltipItem.label + langDashboard.total + tooltipItem.value;
            case langDashboard.districtHki:
              if (Object.values(districtHkiOptions).includes(tooltipItem.label)) {
                return tooltipItem.label + langDashboard.total + tooltipItem.value;
              }
              break;
            case langDashboard.districtKln:
              if (Object.values(districtKltOptions).includes(tooltipItem.label)) {
                return tooltipItem.label + langDashboard.total + tooltipItem.value;
              }
              break;
            case langDashboard.districtNt:
              if (Object.values(districtNtOptions).includes(tooltipItem.label)) {
                return tooltipItem.label + langDashboard.total + tooltipItem.value;
              }
              break;
          }
      }
    }

  },
  layout: { padding: 0 },
  scales: {
    xAxes: [
      {
        // barThickness: 12,
        // maxBarThickness: 10,
        // barPercentage: 0.5,
        // categoryPercentage: 0.5,
        // stacked: true,
        ticks: {
          fontColor: palette.text.secondary,
          beginAtZero: true,
          precision:0,
          min: 0,
          callback: function (value) {
            return value >= 1000000 ? handlePriceDisplay(value, locale) + handlePriceDisplayUnit(value, locale, lang) : value;
          }
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: palette.divider
        },
        scaleLabel: {
          display: true,
          labelString: langDashboard.numberOfpropertyUpdates,
        }
      }
    ],
    yAxes: [
      {
        stacked: true,
        ticks: {
          fontColor: palette.text.secondary,
          // beginAtZero: true,
          // min: 0
        },
        gridLines: {
          display: false,
          drawBorder: false
        },
        scaleLabel: {
          display: true,
          labelString: langDashboard.district,
        }
      }
    ]
  }
}
);
